import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dimensionCategoriesEntriesSelector } from "@/store/dimensions/selectors/slice-data/categories/dimensionCategoriesEntriesSelector";

export const dimensionCategoriesIdsWithNamesSelector = createDraftSafeSelector(
  [dimensionCategoriesEntriesSelector],
  (categoriesEntries) => {
    return categoriesEntries.reduce(
      (acc, [, category]) => {
        acc[category.id] = category.name;

        return acc;
      },
      {} as Record<string, string>,
    );
  },
);
